/* Constants */
import { UNIQUE_PATHS_OF_CATEGORY } from '@/constants/uniquePathsOfCategory'

import { defineNuxtRouteMiddleware, navigateTo } from '#app'

/*
    Редирект для нового slug-а продукта /product/
    Нужен для того, чтобы переход по старым ссылкам продуктов
    сопровождался 301 редиректом для новых ссылок продуктов
*/
export default defineNuxtRouteMiddleware(({ params, query }) => {
  try {
    if (!(`/${params.categories}/` in UNIQUE_PATHS_OF_CATEGORY)) return

    return navigateTo(
      { path: `/product/${params?.product}/`, query },
      { redirectCode: 301 },
    )
  } catch (error) {
    const { $sentryCaptureException } = useNuxtApp()

    $sentryCaptureException(`RedirectToNewProduct упал с ошибкой: ${error}`)
  }
})
